import {HttpClient} from '@angular/common/http';
import {EventEmitter, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ApiUrlsEnum, StoreKeyEnum} from '../enums';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {StoreService} from './store-service.service';
import {WebsocketService} from './websocket.service';
import {ILoginDto, LoggedUserInterface} from '../interfaces';
import {routes, SiteRouteEnum} from "@ui/modules/sidebar/routes";
import {UserActionEnum} from "@ui/directives/access/user-action.enum";
import {UserRoleEnum} from "@ui/directives/access/user-role.enum";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public readonly loggedUser$ = new BehaviorSubject<LoggedUserInterface | null>(null);
  public readonly userLoggedIn$ = new EventEmitter<void>();

  private readonly authUrl = ApiUrlsEnum.auth;
  constructor(
    private readonly http: HttpClient,
    private readonly store: StoreService,
    private readonly ws: WebsocketService,
    private readonly router: Router
  ) { }

  public login(dto: ILoginDto): Observable<LoggedUserInterface> {
    return this.http.post<LoggedUserInterface>(`${environment.host}${this.authUrl}`, dto)
      .pipe(
        map((response: any) => {
          this.store.setUser(JSON.stringify(response));

          this.userLoggedIn$.emit();

          this.ws.upConnection.next(true);
          return response;
        }),
        catchError((error) => {
          return throwError(error.error.error);
        }),
      );
  }

  public getUser(): LoggedUserInterface | null {
    const value = this.store.get(StoreKeyEnum.token);

    if (value) {
      return JSON.parse(value) as LoggedUserInterface;
    }

    return null;
  }

  public logout(): void {
    this.store.clearToken();
    this.ws.upConnection.next(false);
    this.router.navigate(['/login']);
  }

  public isUserHasAccessToAction(action: UserActionEnum): boolean {
    const user = this.loggedUser$.getValue();

    if (!user) {
      return false;
    }

    switch (action) {
      case UserActionEnum.RESPONSE_TEMPLATES_ADD: {
        return user.roles.indexOf(UserRoleEnum.SYS_HI_LVL) !== -1;
      }
    }
  }

  public isUserHasRole(role: UserRoleEnum): boolean {
    const user = this.loggedUser$.getValue();

    if (!user) {
      return false;
    }

    return user.roles.indexOf(role) !== -1;
  }

  public isUserHasAccessToRoute(route: SiteRouteEnum): boolean {
    const user = this.loggedUser$.getValue();

    if (!user) {
      return false;
    }

    const foundRoute = routes.find(r => r.routerLink === route);

    if (!foundRoute) {
      return false;
    }

    for (const role of user.roles) {
      if (foundRoute.roles.indexOf(role) !== -1) {
        return true;
      }
    }

    return false;
  }
}
